module.exports = __webpack_public_path__ + "img/L_312_0.cf4de5de.png";